function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "filter-active",
  transform: "translate(-277 -22)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1364",
  "data-name": "Grupo 1364",
  transform: "translate(277 22)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_930",
  "data-name": "Caminho 930",
  d: "M161.472,175.832l-4.956-2.988v-9.631l-9.47-11.381h24.511l-10.085,11.445Zm-3.617-3.743,2.278,1.373V162.77l8.458-9.6H149.9l7.953,9.556Z",
  transform: "translate(-147.046 -151.832)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1913",
  "data-name": "Ret\\xE2ngulo 1913",
  width: 12,
  height: 12,
  transform: "translate(12 3)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "close-btn",
  transform: "translate(292 28)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_505",
  "data-name": "Grupo 505",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1403",
  "data-name": "Ret\\xE2ngulo 1403",
  width: 0.413,
  height: 8.983,
  transform: "translate(0 0.292) rotate(-45)",
  fill: "#9c9c9c",
  stroke: "#757575",
  strokeWidth: 0.6
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_506",
  "data-name": "Grupo 506",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1404",
  "data-name": "Ret\\xE2ngulo 1404",
  width: 8.983,
  height: 0.413,
  transform: "translate(0 6.352) rotate(-45)",
  fill: "#9c9c9c",
  stroke: "#757575",
  strokeWidth: 0.6
}))));

function SvgFilterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.511,
    height: 24,
    viewBox: "0 0 24.511 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActive);
export default __webpack_public_path__ + "static/media/filter-active.ea1e2ba2.svg";
export { ForwardRef as ReactComponent };